var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.sideTab.deposit = !vm.sideTab.deposit\">Close</md-button></div><div layout=\"column\"><h3>Add New Deposit</h3><div flex=\"25\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Date Paid</label><date-picker field=\"vm.models.newDeposit.dateComplete\"></date-picker></div><div flex=\"33\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Amount</label><input ng-model=\"vm.models.newDeposit.amount\" class=\"form-control\"/></div><div flex=\"33\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Description</label><input ng-model=\"vm.models.newDeposit.description\" class=\"form-control\"/></div><div class=\"form-group\"><div ng-click=\"vm.addDeposit()\" class=\"btn btn-primary\">Add Item</div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/addDeposit.jade
// module id = 281
// module chunks = 0